<template>
  <div>
    <button @click="showModal = !showModal" class="btn btn-sm btn-warning mt-1 mr-1" title="Agregar registro"><i class="fas fa-plus"></i> Nuevo</button>
    <b-modal
      v-model="showModal"
      :title="textMessage"
      header-bg-variant="secondary"
      header-text-variant="white"
      scrollable
      @close="close"
      @show="getRecord"
      @hidden="resetForm"
      hide-footer
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
      size="lg">
      <form autocomplete="off" @submit.prevent="submitForm">
        <div class="modal-body">
          <div class="row container-fluid">
            <div class="form-group col-md-12">
              <label for="course"><b>Curso&nbsp;</b><span class="asterisk">*</span></label>
              <v-select v-model="form.coursename" :options="courses" class="my-custom-select" :disabled="courseSelectIsNotEmpty" placeholder="Seleccione..."></v-select>
              <span v-if="courseValid" class="text-danger" style="font-size: 10px;"><b>El campo Curso es requerido.</b></span>
            </div>

            <div class="form-group col-md-12">
              <label for="course"><b>Módulo&nbsp;</b><span class="asterisk">*</span></label>
              <v-select v-model="form.modulename" :options="modules" class="my-custom-select" :disabled="moduleSelectIsNotEmpty" placeholder="Seleccione..."></v-select>
              <span v-if="moduleValid" class="text-danger" style="font-size: 10px;"><b>El campo Módulo es requerido.</b></span>
            </div>

            <div class="form-group col-md-12">
              <label for=""><b>Pregunta&nbsp;</b><span class="asterisk">*</span></label>
              <ckeditor ref="editor" v-model="form.question" :editor="editor" type="classic" :config="editorConfig"></ckeditor>
              <span v-if="questionValid" class="text-danger" style="font-size: 10px;"><b>El campo Pregunta es requerido.</b></span>
            </div>

            <div class="form-group col-md-7 col-lg-8">
              <label for=""><b>Imagen&nbsp;</b></label>
              <input @change="handleFileChange" type="file" class="form-control" id="image" name="image" accept="image/jpg">
            </div>

            <div class="form-group col-md-5 col-lg-4">
              <label for="course"><b>Nivel&nbsp;</b><span class="asterisk">*</span></label>
              <v-select v-model="form.questionLevel" :options="questionLevels" class="my-custom-select" placeholder="Seleccione..."></v-select>
              <span v-if="questionLevelValid" class="text-danger" style="font-size: 10px;"><b>El campo Nivel es requerido.</b></span>
            </div>

            <div class="form-group col-md-8">
              <label for="course"><b>Tipo de Respuesta&nbsp;</b><span class="asterisk">*</span></label>
              <v-select v-model="form.answerType" :options="answerTypes" class="my-custom-select" placeholder="Seleccione..."></v-select>
              <span v-if="answerTypeValid" class="text-danger" style="font-size: 10px;"><b>El campo Tipo de Respuesta es requerido.</b></span>
            </div>

          </div>
          <div class="container">
            <div class="row bg-text">
              <div class="col-12">
                <div class="modal-header">
                  <label for=""><b><u>Explicación para respuesta correcta.</u>&nbsp;<span class="asterisk">*</span></b></label>
                </div>
              </div>
              <div class="modal-body">
                <div class="row container-fluid">

                  <div class="form-group col-12">
                    <label for=""><b>Explicación&nbsp;</b></label>
                    <ckeditor ref="editor" v-model="form.explanation" :editor="editor" type="classic" :config="editorConfig"></ckeditor>
                  </div>

                  <div class="form-group col-6">
                    <label for=""><b>Imagen&nbsp;</b></label>
                    <input @change="handleImgChange" type="file" class="form-control" id="explanation_img" name="explanation_img" accept="image/jpg">
                  </div>

                  <div class="form-group col-6">
                    <label for=""><b>Video&nbsp;</b></label>
                    <input @change="handleVideoChange" type="file" class="form-control" id="explanation_video" name="explanation_video" accept="video/mp4">
                  </div>

                </div>
              </div>
            </div>
          </div>
          <span v-if="explanationValid" class="text-danger" style="font-size: 10px;"><b>Debe poseer minimo un campo para la Explicación.</b></span>
          <input v-model="form.id" type="hidden" class="form-control" id="id" name="id">

        </div>
        <div class="modal-footer d-flex justify-content-end">
          <button class="btn btn-sm btn-danger" type="button" @click="cancel"> <i class="fas fa-times fa-fw"></i>Cancelar</button>
          <button type="submit" class="btn btn-sm btn-success"> <i class="fas fa-download fa-fw"></i> Guardar</button>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { BModal, BFormRadio } from 'bootstrap-vue';
import { ClassicEditor, editorConfig } from '../../../../ckeditor';
import CKEditor from '@ckeditor/ckeditor5-vue2';

export default {
  components: {BModal, vSelect, BFormRadio, 'ckeditor': CKEditor.component},
  props: ['id', 'showModal', 'courseSelect', 'moduleSelect'],
  data() {
    return {
      editor: ClassicEditor,
      editorConfig,
      name: 'ckeditor',
      form: {
        id: null,
        answers: [''],
        typeanswer_id:null,
        questionLevel:null,
        answerType:null,
        image: null,
        explanation: '',
        explanation_img: null,
        explanation_video: null,
      },
      courseValid: false,
      moduleValid: false,
      questionValid: false,
      questionLevelValid: false,
      answerTypeValid: false,
      explanationValid: false,
      loading: false,
      textMessage: 'Crear Pregunta',
      courses: [],
      modules: [],
      coursesSelect: null,
      answerTypes: [],
      questionLevels: [],
      answer_number: null,
      course:null,
    }
  },
  mounted() {
      this.getCourses();
      this.getTypeanswer();
      this.getQuestionlevel();
  },
  computed: {
    courseSelectIsNotEmpty() {
      return this.courseSelect !== 0;
    },
    moduleSelectIsNotEmpty() {
      return this.moduleSelect !== 0;
    }
  },
  watch: {
    'form.coursename'(course) {
      if (!course) {
        this.form.modulename = null;
        this.modules = [];
        this.courseSelect = 0;
      } else {
        axios.get(`/administration/courses/questions/getModules/${course.value}`)
          .then(response => {
            this.modules = response.data.data;
          })
          .catch(error => {
              console.error("Error al obtener módulos:", error);
          });
      }
    },
  },
  methods:{
    resetForm() {
      this.form = {
        id: null,
        answers: [''],
        typeanswer_id: null,
        questionLevel: null,
        answerType: null,
        coursename: null,
        modulename: null,
        question: '',
        image: null,
        explanation: '',
        explanation_img: null,
        explanation_video: null,
      };

      this.courseValid = false;
      this.moduleValid = false;
      this.questionValid = false;
      this.questionLevelValid = false;
      this.answerTypeValid = false;
      this.explanationValid = false;

      this.textMessage = 'Crear Pregunta';
    },
    handleFileChange(event) {
      // Capturar el archivo seleccionado y asignarlo a la propiedad del formulario
      this.form.image = event.target.files[0];
    },
    handleImgChange(event) {
      // Capturar el archivo seleccionado y asignarlo a la propiedad del formulario
      this.form.explanation_img = event.target.files[0];
    },
    handleVideoChange(event) {
      // Capturar el archivo seleccionado y asignarlo a la propiedad del formulario
      this.form.explanation_video = event.target.files[0];
    },
    close() {
      this.$emit('update:showModal', false);
      this.$emit('getRecords');
    },
    cancel() {
      this.$emit('update:showModal', false);
    },
    getCourses() {
      axios.get(`/administration/courses/questions/getCourses`)
        .then(response => {
          this.courses = response.data.data;
          if(this.courseSelect != 0){
            this.form.coursename = {
              value: this.courseSelect.value,
              label: this.courseSelect.label,
            };
            this.getModules(this.courseSelect.value);
          };
        });
    },
    getModules(course_id=null) {
      axios.get(`/administration/courses/questions/getModules/${course_id}`)
        .then(response => {
          this.modules = response.data.data;
          if(this.moduleSelect != 0){
            this.form.modulename= {
              value: this.moduleSelect.value,
              label: this.moduleSelect.label,
            };
          }
        })
    },
    getQuestionlevel() {
      axios.get(`/administration/courses/questions/getQuestionlevels`)
        .then(response => {
          this.questionLevels = response.data.data;
        })
    },
    getTypeanswer() {
      axios.get(`/administration/courses/questions/getTypeanswers`)
        .then(response => {
          this.answerTypes = response.data.data;
        })
    },
    getRecord() {
      this.loading = true
      if(this.id) {
        axios.get(`/administration/courses/questions/${this.id}`)
        .then(response => {
            this.textMessage = 'Editar Pregunta';
            this.form.id = response.data.id;
            this.form.question = response.data.question;
            this.form.explanation = response.data.explanation;

            this.form.coursename = {
              value: response.data.coursename.value,
              label: response.data.coursename.label
            };

            this.coursesSelect = response.data.coursename.value

            this.form.modulename = {
              value: response.data.modulename.value,
              label: response.data.modulename.label
            };

            this.form.questionLevel = {
              value: response.data.levelQuestion.value,
              label: response.data.levelQuestion.label
            };

            this.form.answerType = {
              value: response.data.typeAnswer.value,
              label: response.data.typeAnswer.label
            };

            // Llama a getModules con el ID del curso seleccionado al editar
            this.getModules(response.data.coursename.value);
        })
        .finally(() => {
          this.loading = false
        })
      } else {
        this.form = {}
      }
    },
    submitForm() {
      this.loading = true;

      this.courseValid= false;
      this.moduleValid= false;
      this.questionValid= false;
      this.questionLevelValid= false;
      this.answerTypeValid= false;
      this.explanationValid= false;

      // Validar campos
      if (this.form.coursename == '' || this.form.coursename == null) {
        this.courseValid = true;
      }

      if (this.form.modulename == '' || this.form.modulename == null) {
        this.moduleValid = true;
      }

      if (this.form.question == '' || this.form.question == null) {
        this.questionValid = true;
      }

      if (this.form.questionLevel == '' || this.form.questionLevel == null) {
        this.questionLevelValid = true;
      }

      if (this.form.answerType == '' || this.form.answerType == null) {
        this.answerTypeValid = true;
        this.answer_numberValid = true;
      }

      if (!this.form.explanation && !this.form.explanation_img && !this.form.explanation_img) {
          this.explanationValid = true;
      }

      // Si algún campo no es válido, detener el envío del formulario
      if (this.courseValid == true || this.moduleValid == true || this.questionValid == true || this.questionLevelValid == true || this.answerTypeValid == true || this.explanationValid == true) {
        return;
      }

      let formData = new FormData();

      // Verificar si this.id está definido
      if (this.id) {
        formData.append('id', this.form.id);
      } else {
        // Si this.id no está definido, asignar null a this.form.id
        this.form.id = null;
      }

      formData.append('course_id', this.form.coursename.value);
      formData.append('module_id', this.form.modulename.value);
      formData.append('image', this.form.image);
      formData.append('question', this.form.question);
      formData.append('questionlevel_id', this.form.questionLevel['value']);
      formData.append('typeanswer_id', this.form.answerType['value']);
      formData.append('explanation', this.form.explanation);
      formData.append('explanation_img', this.form.explanation_img);
      formData.append('explanation_video', this.form.explanation_video);


      // Validar y agregar la imagen solo si está presente
      if (this.form.image) {
        // const imageSizeLimit = 380 * 250; // Tamaño máximo permitido en píxeles
        // const imageFile = this.form.image;

        // if (imageFile.type !== 'image/jpeg') {
        //   toastr.error('La imagen debe estar en formato JPG.', 'Error', { icon: 'fa fa-times-circle' });
        //   this.loading = false;
        //   return;
        // }

        // const img = new Image();
        // img.src = URL.createObjectURL(imageFile);

        // img.onload = function () {
        //   const width = img.width;
        //   const height = img.height;

        //   if (width !== 380 || height !== 250) {
        //     toastr.error('La imagen debe tener un tamaño de 380x250 píxeles.', 'Error', { icon: 'fa fa-times-circle' });
        //     this.loading = false;
        //     return;
        //   }

          // Si la imagen cumple con los requisitos, agregarla al formulario
          formData.append('image', this.form.image);

        // }.bind(this);
      } else {
        // Si no se proporciona una imagen, continuar con el envío del formulario sin agregarla
        formData.append('image', null);
      }

      // Validar y agregar la imagen solo si está presente
      if (this.form.explanation_img) {
        // const imageSizeLimit = 380 * 250; // Tamaño máximo permitido en píxeles
        // const imageFile = this.form.image;

        // if (imageFile.type !== 'image/jpeg') {
        //   toastr.error('La imagen debe estar en formato JPG.', 'Error', { icon: 'fa fa-times-circle' });
        //   this.loading = false;
        //   return;
        // }

        // const img = new Image();
        // img.src = URL.createObjectURL(imageFile);

        // img.onload = function () {
        //   const width = img.width;
        //   const height = img.height;

        //   if (width !== 380 || height !== 250) {
        //     toastr.error('La imagen debe tener un tamaño de 380x250 píxeles.', 'Error', { icon: 'fa fa-times-circle' });
        //     this.loading = false;
        //     return;
        //   }

          // Si la imagen cumple con los requisitos, agregarla al formulario
          formData.append('explanation_img', this.form.explanation_img);

        // }.bind(this);
      } else {
        // Si no se proporciona una imagen, continuar con el envío del formulario sin agregarla
        formData.append('explanation_img', null);
      }

      // Envío del formulario
      this.sendForm(formData);
    },

    sendForm(formData) {
      axios.post('/administration/courses/questions', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(response => {
        if (response.data.status == 'error') {
          toastr.error(response.data.message, 'Error', { icon: 'fa fa-times-circle' });
        } else {
          toastr.success(response.data.message, 'Realizado', { icon: 'fa fa-check-circle' });
        }
        this.close();
      })
      .catch(error => {
        console.error(error);
      })
      .finally(() => {
        this.loading = false;
      });
    },
    filterOptions(options, search, label) {
      // Puedes personalizar la lógica de filtrado según tus necesidades
      return options.filter(option => option[label].toLowerCase().includes(search.toLowerCase()));
    },
  }
}

</script>
<style>
#__BVID__6___BV_modal_outer_ {
  /*z-index: 1000 !important;*/
  z-index: calc(var(--ck-z-panel) + 40) !important;
}
.ck-rounded-corners .ck.ck-balloon-panel {
  z-index: calc(var(--ck-z-panel) + 41) !important;
}
</style>